import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors, getPypeRuleGroups, type RuleSet } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

/** Deletes a masking rule set, then re-fetches the project's rule sets. */
export const deletePypeRuleGroup = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ pypeRuleGroups: RuleSet[]; cb?: () => void } | void> => {
  if (event.type !== 'deletePypeRuleGroup') {
    return;
  }

  const projectId = ctx.project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  const { id, cb } = event.payload;

  const response = await urqlGql.deletePypeRuleGroup({ id });
  checkForErrors(response);

  const pypeRuleGroups = await getPypeRuleGroups({ projectId });

  return { pypeRuleGroups, cb };
};
